import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import i18n from '../../../i18n'
import EsgProductRow from './EsgProductRow'
import './Esg.css'
import { setMetricQuality, setAllGrowthChars, setSeeAdditionalPI } from '../../../actions'
import EsgCharts from './EsgCharts'
//import EsgOverallMetric from './EsgOverallMetric';
import EsgRiskRatingRow from './EsgRiskRatingRow'
import ProgressBar from '../Components/ProgressBar'
import { SomethingWentWrong } from '../Components/ErrorHandle'
import { UseSelector } from 'react-redux/es/hooks/useSelector'

class Esg extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMoreChars: false,
      chartType: { value: 'SalesGrowth', label: 'Sales Growth' }
    }
  }

  handleChartTypeChange = chartType => {
    this.setState({ chartType: chartType })
  }

  toggleShowMoreChars() {
    this.setState(
      Object.assign({}, this.state, {
        showMoreChars: !this.state.showMoreChars
      })
    )
  }

  asOfDate() {
    const { data } = this.props
    const fundsWithEsgMetrics = data.filter(x => x.esgOverallMetrics !== null)
    if (fundsWithEsgMetrics.length > 0) {
      const fund = fundsWithEsgMetrics[0]
      const value = fund['esgOverallMetrics'][fund['esgOverallMetrics'].length - 1]
      return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0]
    } else {
      return ''
    }
  }

  setMetricType(type) {
    this.props.setMetricQuality(type)
  }

  viewAdditionalPi() {
    this.props.setSeeAdditionalPI(true)
  }

  // create the header row
  renderProdInvolvementHeader(type) {
    const { data } = this.props

    const EqIncFund = data.filter(x => x.assetClass !== 'Fixed Income')

    const tickerList = data.map(fund => {
      if ((fund.type === 'BMK' || fund.type === 'BLEND')) {
        return (
          <th key={fund.ticker} className='textCenter'>
            {fund.ticker.toUpperCase()}
          </th>
        )
      } else {
        return (
          <th key={fund.ticker} className='textCenter'>
            {fund.fundPageURL && (
              <a className='tickerLinkFC' href={fund.fundPageURL} target='_new'>
                {fund.ticker}
              </a>
            )}
            {!fund.fundPageURL && (
              <a className='tickerLinkFC' href={fund.msUrl} target='_new'>
                {fund.ticker}
              </a>
            )}
          </th>
        )
      }
    })

    if (type === 'Product Involvement Data' && EqIncFund.length > 0) {
      return (
        <tr>
          <th className='textLeft'>
            {i18n.t('product-involvement-exposure')} {i18n.t('as of')} {this.asOfDate()}
            <br />
            <span style={{ fontStyle: 'italic' }}> {i18n.t('prod-involvement-blurb')}</span>
            <br />
            <span style={{ fontStyle: 'italic' }}> {i18n.t('select-esgmetric')}</span>
          </th>
          {tickerList}
        </tr>
      )
    }
  }

  renderBasicProdInvolvementRows() {
    const chars = [
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Alcohol', name: 'Alcohol', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Arctic Oil & Gas', name: 'ArcticOilGas', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Thermal Coal', name: 'ThermalCoal', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Tobacco', name: 'Tobacco', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Small Arms', name: 'SmallArms', type: '.000%', append: '' }
    ]

    return chars.map(char => {
      return <EsgProductRow key={char.name} displayName={char.displayName} displayGroup={char.displayGroup} subGroup={char.subGroup} charName={char.name} charType={char.type} minmax={char.minmax} bold={char.bold} append={char.append} />
    })
  }

  renderAllProdInvolvementRows() {
    const chars = [
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Alcohol', name: 'Alcohol', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Artic Oil & Gas', name: 'ArcticOilGas', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Thermal Coal', name: 'ThermalCoal', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Tobacco', name: 'Tobacco', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Small Arms', name: 'SmallArms', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Abortion', name: 'Abortion', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Adult Entertainment', name: 'AdultEntertainment', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Animal Testing', name: 'AnimalTesting', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Contraceptives', name: 'Contraceptives', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Controversial Weapons', name: 'ControversialWeapons', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Fur Leather', name: 'FurLeather', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Gambling', name: 'Gambling', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'GMO', name: 'GMO', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Military Contracting', name: 'MilitaryContracting', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Nuclear Power', name: 'NuclearPower', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Oil Sands', name: 'OilSands', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Palm Oil', name: 'PalmOil', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Pesticides', name: 'Pesticides', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Pork Products', name: 'PorkProducts', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Predatory Lending', name: 'PredatoryLending', type: '.000%', append: '' },
      { displayGroup: 'prod-involvement', bold: 'max', displayName: 'Stem Cell', name: 'StemCell', type: '.', append: '%' }
    ]

    return chars.map(char => {
      return <EsgProductRow key={char.name} displayName={char.displayName} displayGroup={char.displayGroup} subGroup={char.subGroup} charName={char.name} charType={char.type} minmax={char.minmax} bold={char.bold} append={char.append} />
    })
  }

  getOverallRiskValues(data) {
    return data.map(fund => {
      if (fund.esgOverallMetrics) {
        const term = 'esgRiskScore'
        const overallKeys = fund.esgOverallMetrics[fund.esgOverallMetrics.length - 1].keys
        const keyIdx = overallKeys.indexOf(term)
        if (keyIdx !== -1) {
          return fund.esgOverallMetrics[fund.esgOverallMetrics.length - 1].values[keyIdx]
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    })
  }

  getPeerGroupValues(data) {
    let peerData = []
    peerData = data.map(fund => {
      if (fund.esgOverallMetrics) {
        const term = 'pgESGRiskScore'
        const term2 = 'pgCount'
        const overallKeys = fund.esgOverallMetrics[fund.esgOverallMetrics.length - 1].keys
        const peerGrpIdx = overallKeys.indexOf(term)
        const numFundIdx = overallKeys.indexOf(term2)
        const peerGrpVal = peerGrpIdx !== -1 ? (fund.esgOverallMetrics[fund.esgOverallMetrics.length - 1].values[peerGrpIdx] * 100).toFixed(2) : '-'
        const numFundVal = numFundIdx !== -1 ? fund.esgOverallMetrics[fund.esgOverallMetrics.length - 1].values[numFundIdx] : '-'
        if (peerGrpIdx !== -1) {
          return peerGrpVal + '--' + numFundVal + '--peer'
        }
      }
      return null
    })
    return peerData
  }

  getPeerGroupTooltip(data) {
    let peerData = []
    peerData = data.map(fund => {
      if (fund.esgPeerGroupCategory) {
        return fund.esgPeerGroupCategory
      } else return 'N/A'
    })
    return peerData
  }

  getFeesTooltooltips(data) {
    return data.map(fund => {
      if (fund.expenseRatio) {
        let toReturn = `Net Fees: ${(fund.expenseRatio * 100).toFixed(2)}%<br />Gross Fees: ${(fund.expenseRatioGross * 100).toFixed(2)}%`
        if (fund.expenseNotes) {
          toReturn = `${toReturn}<br /><br />${fund.expenseNotes}`
        }
        return toReturn
      } else {
        return null
      }
    })
  }

  // create the Risk header row
  renderRiskHeader(type) {
    const { data } = this.props

    const EqIncFund = data.filter(x => x.assetClass !== 'Fixed Income')
    const tickerList = data.map(fund => {
      if ((fund.type === 'BMK' || fund.type === 'BLEND')) {
        return (
          <th key={fund.ticker} className='textCenter'>
            {fund.ticker.toUpperCase()}
          </th>
        )
      } else {
        return (
          <th key={fund.ticker} className='textCenter'>
            {fund.fundPageURL && (
              <a className='tickerLinkFC' href={fund.fundPageURL} target='_new'>
                {fund.ticker}
              </a>
            )}
            {!fund.fundPageURL && (
              <a className='tickerLinkFC' href={fund.msUrl} target='_new'>
                {fund.ticker}
              </a>
            )}
          </th>
        )
      }
    })

    if (type === 'esgRiskRating' && EqIncFund.length > 0) {
      return (
        <tr>
          <th colSpan='2' className='textLeft'>
            {i18n.t('overall-risk-rating')} {i18n.t('as of')} {this.asOfDate()}
            <br />
          </th>
          {tickerList}
        </tr>
      )
    }
  }
  //render the risk rows
  renderRiskRating() {
    const { data } = this.props
    const metrics = [
      {
        bold: 'min',
        displayName: 'ESG Risk Rating',
        charName: 'overallRisk',
        name: 'ESG Risk Rating',
        description: 'Overall Exposure to ESG Risk (lower is better)',
        values: this.getOverallRiskValues(data)
      },
      {
        bold: 'max',
        displayName: 'ESG Risk Rating Morningstar Peer Group Percentile',
        charName: 'peerPercentile',
        name: 'Peer Group ',
        type: '.',
        // append: '',
        description: 'Relative ESG Risk Rating Score vs. Morningstar Peer Group (higher is better) / number of funds',
        tooltips: this.getPeerGroupTooltip(data),
        values: this.getPeerGroupValues(data)
      }
    ]

    return metrics.map(metric => {
      return <EsgRiskRatingRow key={metric.displayName} displayName={metric.displayName} charName={metric.charName} description={metric.description} values={metric.values} append={metric.append} bold={metric.bold} hideLine={metric.hideLine} tooltips={metric.tooltips} type={metric.type} name={metric.name} />
    })
  }

  render() {
    const { data, params, loadingRunID, errorCatchAll} = this.props

    // const EqIncFund = data.filter(x => x.assetClass !== 'Fixed Income')
    const fundsWithEsg = data.filter(x => x.esgOverallRiskMetrics !== null)
    const seeAdditionalPI = params.seeAdditionalPIFlag

    const ComplianceText = () => {
      return(
        <div className='introCopy'>
        <div className='esgOverall'>{i18n.t('product-Involvement-comp')}</div>
        <br />
        <div className='esgOverall'>{i18n.t('sustain-analytics-disclaimer')}</div>
        </div>
      )
    }

    if (errorCatchAll) {
      return (
        <div>
          <SomethingWentWrong />
          <ComplianceText />
        </div>
      )
    }    

    if (fundsWithEsg.length === 0 && loadingRunID) {
      return (
        <div>
          <ProgressBar title={'FUND ESG'} message={i18n.t('loading_esg')} />
          <ComplianceText />
        </div>
      )
    }
    


    if (fundsWithEsg.length === 0) {
      return (
        <div>
          <div className='noData'>{i18n.t('no-data')}</div>
          <ComplianceText />
        </div>
      )
    }
    
    /***********  Main table Return Starts Here  ************/
    return (
      <div className='fund-char-esg'>
        <div className={'table-responsive'}>
          {fundsWithEsg.length > 0 && (
            <React.Fragment>
              <div className='intro'>
                {i18n.t('intro-paragraph')}
                &nbsp;&nbsp;&nbsp;
              </div>
              <table className='table tableFC'>
                <thead>{this.renderRiskHeader('esgRiskRating')}</thead>
                {this.renderRiskRating()}
              </table>
              <div className='esgOverall'>{i18n.t('esg-scores')}</div>
              <div className='esgOverall'>{i18n.t('esg-risk-rating')}</div>
              <div className='esgOverallPeerGroup'>{i18n.t('peer-group-percentile')}</div>

              <EsgCharts />
              <div className='introCopy'>
                <div className='riskRating'>{i18n.t('risk-rating-dist-cats')} </div>
                <div className='riskRating'>{i18n.t('risk-rating-distrib-group')} </div>
              </div>
              <table className='table tableFC'>
                <thead>{this.renderProdInvolvementHeader('Product Involvement Data')}</thead>
                {seeAdditionalPI === false && (
                  <Fragment>
                    <tbody>{this.renderBasicProdInvolvementRows()}</tbody>
                    <div style={{ marginTop: '15px' }}>
                      <a onClick={() => this.viewAdditionalPi()}>{i18n.t('see-additional-pi')}</a>
                    </div>
                  </Fragment>
                )}
                {seeAdditionalPI === true && (
                  <Fragment>
                    <tbody>{this.renderAllProdInvolvementRows()}</tbody>
                  </Fragment>
                )}
              </table>
            </React.Fragment>
          )}
          <ComplianceText />
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    params: state.params,
    hasBlendedData: state.fundData.hasBlendedData,
    loadingRunID: state.fundData.loadingRunID,
    errorCatchAll: state.fundData.errorCatchAll
  }
}

export default connect(mapStateToProps, {
  setMetricQuality,
  setAllGrowthChars,
  setSeeAdditionalPI
})(Esg)
